// extracted by mini-css-extract-plugin
module.exports = {"organizationsStatsCardContainer":"styles_organizationsStatsCardContainer__1fjud","organizationsStatsCardWrapper":"styles_organizationsStatsCardWrapper__72Qph"};